import { Routes } from '@angular/router';
import { loggedWithRoles } from '@common/lib/services/auth/auth.guards';

export { appRoutes, routesConfig };

const appRoutes = {
  onboarding: (rp = '/') => `${rp}onboarding`,
  settings: {
    default: (rp = '/') => `${rp}settings`,
    installationSettings: (rp = '/settings/') => `${rp}installation-settings`,
    workflows: {
      validationCircuits: (rp = '/settings/workflows/') => `${rp}validation-circuits`,
      automations: (rp = '/settings/workflows/') => `${rp}automations`,
    },
    properties: (rp = '/settings/') => `${rp}properties`,
    operators: (rp = '/settings/') => `${rp}operators`,
    dataExports: (rp = '/settings/') => `${rp}data-exports`,
    smartDrives: (rp = '/settings/') => `${rp}smart-drives`,
  },
};

const routesConfig: Routes = [
  // Onboarding route - requires authentication but accessible to all logged users
  {
    path: appRoutes.onboarding(''),
    // canActivate: [loggedWithRoles()],
    loadComponent: () => import('../../pages/onboarding/onboarding.component'),
  },
  // Group route to protect all children
  {
    path: '',
    canActivate: [loggedWithRoles()],
    children: [
      {
        path: appRoutes.settings.default(''),
        loadComponent: () => import('../../pages/settings/settings.component'),
        children: [
          {
            path: appRoutes.settings.installationSettings(''),
            canActivate: [loggedWithRoles('google_domain_admin')],
            loadComponent: () => import('../../pages/settings/installation-settings/installation-settings.component'),
          },
          {
            path: 'workflows',
            children: [
              {
                path: appRoutes.settings.workflows.validationCircuits(''),
                canActivate: [loggedWithRoles('domain_operator')],
                loadComponent: () =>
                  import('../../pages/settings/workflows/validation-circuits/validation-circuits.component'),
              },
              {
                path: appRoutes.settings.workflows.automations(''),
                canActivate: [loggedWithRoles('domain_operator')],
                loadComponent: () => import('../../pages/settings/workflows/automations/automations.component'),
              },
            ],
          },
          {
            path: appRoutes.settings.properties(''),
            canActivate: [loggedWithRoles('domain_operator')],
            loadComponent: () => import('../../pages/settings/properties/properties.component'),
          },
          {
            path: appRoutes.settings.operators(''),
            canActivate: [loggedWithRoles('google_domain_admin')],
            loadComponent: () => import('../../pages/settings/domain-operators/domain-operators.component'),
          },
          {
            path: appRoutes.settings.dataExports(''),
            canActivate: [loggedWithRoles('domain_operator')],
            loadComponent: () => import('../../pages/settings/data-exports/data-exports.component'),
          },
          {
            path: appRoutes.settings.smartDrives(''),
            canActivate: [loggedWithRoles('domain_operator')],
            loadComponent: () => import('../../pages/settings/smart-drive/smart-drive.component'),
          },
          {
            path: '',
            redirectTo: appRoutes.settings.installationSettings(''),
            pathMatch: 'full',
          },
        ],
      },
      {
        path: '',
        redirectTo: appRoutes.settings.default(),
        pathMatch: 'full',
      },
    ],
  },
];
